import { NgModule } from '@angular/core';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { BingMapComponent } from './bing-map.component';

@NgModule({
    declarations: [
        BingMapComponent
    ],
    entryComponents: [
        BingMapComponent
    ],
    exports: [
        BingMapComponent
    ],

})
export class BingMapModule {
    private commonModuleName = 'app.areas.commonModule';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            BingMapComponent
        ]);
    }
}